// Centralized logging utility for controlling debug output levels
// This allows filtering out verbose debug messages from devtools and action cable

const LogLevel = {
  DEBUG: 0,
  INFO: 1,
  WARN: 2,
  ERROR: 3,
  NONE: 4
}

const LogConfig = {
  // Global log level - change this to control what gets logged
  globalLevel: LogLevel.INFO,
  
  // Per-module log levels for fine-grained control
  modules: {
    'preview-devtools': LogLevel.WARN,
    'devtools-cable': LogLevel.WARN,
    'console-log': LogLevel.WARN,
    'dom-inspector': LogLevel.WARN,
    'execution-progress': LogLevel.WARN,
    'automation': LogLevel.INFO,
    'claude-code': LogLevel.INFO,
    'task-execution': LogLevel.INFO,
    'network-monitor': LogLevel.WARN,
    'performance-metrics': LogLevel.WARN,
    'error-tracker': LogLevel.INFO
  }
}

class Logger {
  constructor(moduleName = 'default') {
    this.module = moduleName
    this.moduleLevel = LogConfig.modules[moduleName] ?? LogConfig.globalLevel
  }
  
  shouldLog(level) {
    const moduleLevel = LogConfig.modules[this.module] ?? LogConfig.globalLevel
    return level >= moduleLevel
  }
  
  debug(...args) {
    if (this.shouldLog(LogLevel.DEBUG)) {
      console.debug(`[${this.module}]`, ...args)
    }
  }
  
  info(...args) {
    if (this.shouldLog(LogLevel.INFO)) {
      console.info(`[${this.module}]`, ...args)
    }
  }
  
  log(...args) {
    if (this.shouldLog(LogLevel.INFO)) {
      console.log(`[${this.module}]`, ...args)
    }
  }
  
  warn(...args) {
    if (this.shouldLog(LogLevel.WARN)) {
      console.warn(`[${this.module}]`, ...args)
    }
  }
  
  error(...args) {
    if (this.shouldLog(LogLevel.ERROR)) {
      console.error(`[${this.module}]`, ...args)
    }
  }
}

// Utility functions for runtime configuration
export function setGlobalLogLevel(level) {
  LogConfig.globalLevel = level
}

export function setModuleLogLevel(module, level) {
  LogConfig.modules[module] = level
}

export function getLogConfig() {
  return { ...LogConfig }
}

// Make log levels available for configuration
export { LogLevel }

// Factory function for creating module-specific loggers
export function createLogger(moduleName) {
  return new Logger(moduleName)
}

// Default logger for general use
const defaultLogger = new Logger('app')
export default defaultLogger